import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-wrap items-end justify-end gap-3" }
const _hoisted_2 = { class: "flex flex-col gap-1" }
const _hoisted_3 = { class: "text-xs font-medium text-gray-400" }
const _hoisted_4 = { class: "inline-flex rounded-lg border border-gray-200 bg-white p-0.5" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: "loading",
  class: "flex items-center justify-center px-4 py-16"
}
const _hoisted_7 = {
  key: "error",
  class: "flex flex-col items-center gap-3 rounded-md border border-red-200 bg-red-50 px-4 py-6 text-center text-red-700"
}
const _hoisted_8 = { class: "text-base font-medium" }
const _hoisted_9 = {
  key: "empty",
  class: "flex items-center justify-center px-4 py-16"
}
const _hoisted_10 = { class: "text-center text-gray-500" }
const _hoisted_11 = ["aria-busy"]
const _hoisted_12 = {
  class: "w-full text-sm",
  style: {"table-layout":"fixed","border-collapse":"collapse"}
}
const _hoisted_13 = { class: "border-b border-gray-200 text-left text-[11px] font-semibold uppercase tracking-wide text-gray-400" }
const _hoisted_14 = { class: "py-2 pr-2" }
const _hoisted_15 = { class: "py-2 pr-4" }
const _hoisted_16 = { class: "py-2 pr-2" }
const _hoisted_17 = { class: "py-2 pr-1 text-right" }
const _hoisted_18 = {
  colspan: "5",
  class: "pl-2 pr-2 pt-3 pb-1"
}
const _hoisted_19 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_20 = { class: "text-[12px] font-semibold text-gray-500" }
const _hoisted_21 = {
  key: 0,
  class: "text-[11px] font-medium text-gray-400"
}
const _hoisted_22 = ["title", "aria-expanded", "aria-label", "onClick"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  colspan: "5",
  class: "py-2 pl-2 pr-2"
}

import { LineChart } from 'lucide-vue-next';
import DashboardContentLayout from '@/components/layouts/dashboardLayout/content/DashboardContentLayout.vue';
import FadeTransition from '@/components/transitions/FadeTransition.vue';
import Spinner from '@/components/ui/Spinner.vue';
import { Button } from '@/components/ui/button';
import ManageObjectivesModal from '@/components/common/objectives/ManageObjectivesModal.vue';
import TopPerformersModal from './TopPerformersModal.vue';
import BarnRow from './BarnRow.vue';
import ObjectiveTrendSparkline from './ObjectiveTrendSparkline.vue';
import { resolveFarmUniformTarget } from './objectiveRow';
import { useObjectivesPage } from './useObjectivesPage';


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const {
    isWeaners,
    referenceWindowOptions,
    referenceWindowWeeks,
    selectReferenceWindow,
    isLoading,
    isError,
    refetch,
    isRefetchingPlaceholder,
    farmGroups,
    hasFarms,
    refetchAll,
    historyByFarmId,
    trendDirectionFor,
    leaderboard,
    leaderboardDisabledReason,
    barCeiling,
    isExpanded,
    toggle,
    isChartExpanded,
    toggleChart,
    targetsModal,
    openTargetsFor,
} = useObjectivesPage();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DashboardContentLayout, {
    class: "space-y-6",
    heading: _ctx.$t('views.objectives.header.heading'),
    "has-pig-type-picker": true,
    "slim-pig-type-picker": true
  }, {
    default: _withCtx(() => [
      _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "border-t border-t-gray-200 mt-5 mb-6",
        "aria-hidden": "true"
      }, null, -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('views.objectives.referenceWindow.label')), 1),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(referenceWindowOptions), (option) => {
              return (_openBlock(), _createElementBlock("button", {
                key: option,
                type: "button",
                class: _normalizeClass(["rounded-md px-3 py-1.5 text-sm font-medium transition-colors", _unref(referenceWindowWeeks) === option ? 'bg-primary-700 text-white' : 'text-gray-600 hover:bg-gray-100']),
                onClick: ($event: any) => (_unref(selectReferenceWindow)(option))
              }, _toDisplayString(_ctx.$t('views.objectives.referenceWindow.weeksOption', { count: option })), 11, _hoisted_5))
            }), 128))
          ])
        ]),
        _createVNode(ManageObjectivesModal, {
          ref_key: "targetsModal",
          ref: targetsModal,
          "is-weaner": _unref(isWeaners),
          onSaved: _unref(refetchAll)
        }, null, 8, ["is-weaner", "onSaved"]),
        _createVNode(TopPerformersModal, {
          best: _unref(leaderboard).best,
          worst: _unref(leaderboard).worst,
          "disabled-reason": _unref(leaderboardDisabledReason),
          "window-weeks": _unref(referenceWindowWeeks)
        }, null, 8, ["best", "worst", "disabled-reason", "window-weeks"])
      ]),
      _createVNode(FadeTransition, { mode: "out-in" }, {
        default: _withCtx(() => [
          (_unref(isLoading))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(Spinner, { class: "h-10 w-10" })
              ]))
            : (_unref(isError))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('views.objectives.texts.loadError')), 1),
                  _createVNode(_unref(Button), {
                    variant: "secondary",
                    size: "sm",
                    onClick: _unref(refetch)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('views.objectives.texts.retry')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
              : (!_unref(hasFarms))
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('views.objectives.texts.noFarms')), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", {
                    key: "content",
                    class: _normalizeClass(["mt-2 rounded-xl border border-gray-200 bg-white p-4 transition-opacity", { 'pointer-events-none opacity-50': _unref(isRefetchingPlaceholder) }]),
                    "aria-busy": _unref(isRefetchingPlaceholder)
                  }, [
                    _createElementVNode("table", _hoisted_12, [
                      _cache[1] || (_cache[1] = _createElementVNode("colgroup", null, [
                        _createElementVNode("col", { style: {"width":"15rem"} }),
                        _createElementVNode("col", { style: {"width":"9rem"} }),
                        _createElementVNode("col", { style: {"width":"3.5rem"} }),
                        _createElementVNode("col", { style: {"width":"5rem"} }),
                        _createElementVNode("col", { style: {"width":"4.5rem"} })
                      ], -1)),
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", _hoisted_13, [
                          _cache[0] || (_cache[0] = _createElementVNode("th", { class: "py-2 pl-2 pr-2" }, null, -1)),
                          _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('views.objectives.texts.mortalityColumnHeader')), 1),
                          _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('views.objectives.texts.trendColumnHeader')), 1),
                          _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('views.objectives.texts.pigsToTargetColumnHeader')), 1),
                          _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('views.objectives.texts.deadColumnHeader')), 1)
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(farmGroups), (farm) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: farm.id
                          }, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                  _createElementVNode("span", _hoisted_20, _toDisplayString(farm.name), 1),
                                  (_unref(resolveFarmUniformTarget)(farm) != null)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, " · " + _toDisplayString(_ctx.$t('views.objectives.texts.targetCaption', { value: _ctx.$n(_unref(resolveFarmUniformTarget)(farm) as number, 'decimal') })), 1))
                                    : _createCommentVNode("", true),
                                  (_unref(historyByFarmId).get(farm.id))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        type: "button",
                                        class: _normalizeClass(["ml-auto grid h-6 w-6 shrink-0 place-content-center rounded-md transition-colors hover:bg-gray-100", _unref(isChartExpanded)(farm.id) ? 'bg-primary-50 text-primary-700' : 'text-gray-400 hover:text-gray-600']),
                                        title: _unref(isChartExpanded)(farm.id) ? _ctx.$t('views.objectives.texts.hideTrend') : _ctx.$t('views.objectives.texts.showTrend'),
                                        "aria-expanded": _unref(isChartExpanded)(farm.id),
                                        "aria-label": `${_unref(isChartExpanded)(farm.id) ? _ctx.$t('views.objectives.texts.hideTrend') : _ctx.$t('views.objectives.texts.showTrend')}: ${farm.name}`,
                                        onClick: ($event: any) => (_unref(toggleChart)(farm.id))
                                      }, [
                                        _createVNode(_unref(LineChart), {
                                          class: "h-4 w-4",
                                          "aria-hidden": "true"
                                        })
                                      ], 10, _hoisted_22))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(farm.barns, (barn) => {
                              return (_openBlock(), _createBlock(BarnRow, {
                                key: barn.id,
                                barn: barn,
                                expanded: _unref(isExpanded)(barn.id),
                                ceiling: _unref(barCeiling),
                                "farm-location-id": farm.id,
                                "trend-direction": _unref(trendDirectionFor)(farm.id, barn.id),
                                onToggle: ($event: any) => (_unref(toggle)(barn.id)),
                                onSetTarget: _unref(openTargetsFor)
                              }, null, 8, ["barn", "expanded", "ceiling", "farm-location-id", "trend-direction", "onToggle", "onSetTarget"]))
                            }), 128)),
                            (_unref(isChartExpanded)(farm.id) && _unref(historyByFarmId).get(farm.id))
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                                  _createElementVNode("td", _hoisted_24, [
                                    _createVNode(ObjectiveTrendSparkline, {
                                      "farm-name": farm.name,
                                      barns: _unref(historyByFarmId).get(farm.id)!.barns,
                                      "resolved-target": _unref(historyByFarmId).get(farm.id)!.resolvedTarget,
                                      "target-source": _unref(historyByFarmId).get(farm.id)!.targetSource
                                    }, null, 8, ["farm-name", "barns", "resolved-target", "target-source"])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ])
                    ])
                  ], 10, _hoisted_11))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["heading"]))
}
}

})